export class CountryMeta {
  public code: string | undefined;
  public alpha3: string | undefined;
  public fr: string | undefined;
  public en: string | undefined;

  constructor(options?: any) {
    if (options) {
      this.code = options.code;
      this.alpha3 = options.alpha3;
      this.fr = options.fr;
      this.en = options.en;
    }
  }
}
